export const modifyUrlQuery = (url: string, change: object): string => {

  const urlObj = new URL(url)
  Object.entries(change).forEach(([key, value]) => {
    urlObj.searchParams.delete(key)
    urlObj.searchParams.append(key, value)
  })
  return urlObj.toString()

}
